import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  function createSlider(sliderContainer: HTMLElement) {
    const sliderTrack = sliderContainer.querySelector(
      '[data-slider-track]'
    ) as HTMLElement
    const prevBtn = sliderContainer.querySelector(
      '[data-manual-slider-ctrl="prev"]'
    ) as HTMLElement
    const nextBtn = sliderContainer.querySelector(
      '[data-manual-slider-ctrl="next"]'
    ) as HTMLElement

    if (!sliderTrack || !prevBtn || !nextBtn) return

    if (window.innerWidth < 767) {
      sliderTrack.style.scrollSnapType = 'x mandatory'
      sliderTrack.style.overflowX = 'scroll'
    }

    // Apply snap alignment to all children
    Array.from(sliderTrack.children).forEach((child) => {
      const card = child as HTMLElement
      card.removeAttribute('data-module')

      card.style.scrollSnapAlign = 'start'
      card.style.scrollSnapStop = 'always'
    })

    function getCardWidth() {
      const firstCard = sliderTrack.children[0] as HTMLElement
      return firstCard ? firstCard.offsetWidth : 0
    }

    function getTotalCards() {
      return sliderTrack.children.length
    }

    function getVisibleCards() {
      const containerWidth = sliderTrack.offsetWidth
      const cardWidth = getCardWidth()
      return cardWidth > 0 ? Math.floor(containerWidth / cardWidth) : 1
    }

    function updateButtonStates() {
      const scrollLeft = sliderTrack.scrollLeft
      const maxScroll = sliderTrack.scrollWidth - sliderTrack.offsetWidth

      prevBtn.style.opacity = scrollLeft <= 0 ? '0.5' : '1'
      prevBtn.style.pointerEvents = scrollLeft <= 0 ? 'none' : 'auto'

      nextBtn.style.opacity = scrollLeft >= maxScroll ? '0.5' : '1'
      nextBtn.style.pointerEvents = scrollLeft >= maxScroll ? 'none' : 'auto'
    }

    function moveSlider(direction: 'next' | 'prev') {
      const cardWidth = getCardWidth()
      if (cardWidth === 0) return

      const currentScroll = sliderTrack.scrollLeft
      const scrollAmount = direction === 'next' ? cardWidth : -cardWidth

      sliderTrack.scrollTo({
        left: currentScroll + scrollAmount,
        behavior: 'smooth',
      })
    }

    updateButtonStates()

    sliderTrack.addEventListener('scroll', updateButtonStates)
    window.addEventListener('resize', updateButtonStates)

    nextBtn.addEventListener('click', () => moveSlider('next'))
    prevBtn.addEventListener('click', () => moveSlider('prev'))

    return () => {
      sliderTrack.removeEventListener('scroll', updateButtonStates)
      window.removeEventListener('resize', updateButtonStates)
    }
  }

  const cleanupFunctions: (() => void)[] = []

  onMount(() => {
    const sliderContainers = document.querySelectorAll(
      '[data-slider]'
    ) as NodeListOf<HTMLElement>

    sliderContainers.forEach((sliderContainer) => {
      const cleanup = createSlider(sliderContainer)
      if (cleanup) cleanupFunctions.push(cleanup)
    })
  })

  onDestroy(() => {
    cleanupFunctions.forEach((cleanup) => cleanup())
  })
}
